module.exports = '/ng-templates/features/record/kp-new-documents/kp-new-documents.tpl.ftl';
